import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCollection = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M10.5 5.5H20.5C20.7761 5.5 21 5.72386 21 6V11C21 11.2761 20.7761 11.5 20.5 11.5H19V9.5C19 8.39543 18.1046 7.5 17 7.5H10V6C10 5.72386 10.2239 5.5 10.5 5.5ZM8.5 7.5V6C8.5 4.89543 9.39543 4 10.5 4H20.5C21.6046 4 22.5 4.89543 22.5 6V11C22.5 12.1046 21.6046 13 20.5 13H19V14.5C19 15.6046 18.1046 16.5 17 16.5H15.5V18C15.5 19.1046 14.6046 20 13.5 20H3.5C2.39543 20 1.5 19.1046 1.5 18V13C1.5 11.8954 2.39543 11 3.5 11H5V9.5C5 8.39543 5.89543 7.5 7 7.5H8.5ZM6.5 11H13.5C14.6046 11 15.5 11.8954 15.5 13V15H17C17.2761 15 17.5 14.7761 17.5 14.5V9.5C17.5 9.22386 17.2761 9 17 9H7C6.72386 9 6.5 9.22386 6.5 9.5V11ZM3.5 12.5C3.22386 12.5 3 12.7239 3 13V18C3 18.2761 3.22386 18.5 3.5 18.5H13.5C13.7761 18.5 14 18.2761 14 18V13C14 12.7239 13.7761 12.5 13.5 12.5H3.5Z",
		fill: "currentcolor"
	})]
});
export default SvgCollection;
